import { OffCanvas } from "../../../nq-component";
import getMenu from "../utils/getMenu";
import { motion } from "framer-motion";
import Menu from "../../../components/Menu";

export default function Sidebar({
  value,
  user,
  onClickMenu,
  onClick,
  menu,
  buttonLabel,
}) {
  const roles = user ? user.roles.map((role) => role.id) : [];

  return (
    <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
      <div
        className="offcanvas-body bg-white d-flex flex-column justify-content-between"
        style={{
          "::-webkit-scrollbar": { width: "0px" },
        }}
      >
        <nav className="navbar">
          <motion.div
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            className="text-center pt-4 w-100"
          >
            <img src="/f2.png" alt="Forbes" height="100" />
            <p className="p-0 m-0 text-primary fw-bold fs-5 mt-1">Forbes</p>
            <p className="p-0 m-0 text-primary" style={{ fontSize: ".75rem" }}>
              Financial Consultancy Corporation
            </p>
            <p className="p-0 m-0 text-primary fw-bold fs-6 mt-1">
              {user?.firstName} {user?.lastName}
            </p>
          </motion.div>
          <hr className="w-100" />
          <div className="pt-2 w-100">
            <Menu onClickItem={onClickMenu} menus={getMenu(menu, roles)} />
          </div>
        </nav>
        <motion.div
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          className="m-3 d-flex justify-content-center "
        >
          <button
            className="nav-link text-dark btn btn-link bg-secondary ps-4 pe-4 pt-2 pb-2 rounded-pill"
            onClick={onClick}
          >
            <span className="ms-2 fw-semibold small">
              {buttonLabel || "Sign In"}
            </span>
          </button>
        </motion.div>
      </div>
    </OffCanvas>
  );
}
